import { Link } from 'react-router-dom';
import StatsSection from './StatsSection';

// Stats has its own route again (Phase 4.5). It came off Home because it's a
// thing you go and look at occasionally, not part of the daily round - and on
// Home it sat between the scores table and the picks, pushing both down for
// everyone. Reached from the Scores section's footer link.
function Stats() {
  return (
    <div className="max-w-4xl mx-auto px-1">
      <Link
        to="/"
        className="mx-1 mb-2 inline-flex items-center gap-2 transition-opacity duration-150 hover:opacity-80"
      >
        <img src="/img/left_arrow.png" alt="" className="w-4 h-4" />
        <span className="font-semibold text-nlg-text">Home</span>
      </Link>

      <StatsSection />
    </div>
  );
}

export default Stats;
